<script lang="ts">
    import type { AnalyticsProperties } from "../../types";

import { analyticsTrack } from "$lib/analytics"
export let text : string;
export let url : string = "#";
export let theme: 'filled' | 'outlined-blue' | 'outlined-white' | 'purple' | 'cyan' | 'blue' = 'filled'
export let className : string = ''
export let properties : AnalyticsProperties = { action: '', label: '', source_detail: '', source: '', category: '', name: '', }

const trackEvent = (analytics) => {
    if(analytics.action) {
        analyticsTrack(analytics.name, analytics)
    }
}

</script>
<a
    href={url}
    data-sveltekit-reload
    class:filled={theme === 'filled' || theme === 'blue'}
    class:outlined={theme === 'outlined-white' || theme === 'outlined-blue'}
    class:outlined--blue={theme === 'outlined-blue'}
    class:outlined--white={theme === 'outlined-white'}
    class:purple={theme === 'purple'}
    class:cyan={theme === 'cyan'}
    class={className}
    on:click={() => trackEvent(properties)}
>{text}</a>

<style lang="postcss">
    @import '../../styles/_mixins.css';

    .filled {
        @mixin button;
    }

    .outlined {
        @mixin button;
        background:transparent;
        box-shadow: none;
    }

   .outlined--blue {
        color:var(--color_offerzen_cerulean);
        border-color:var(--color_offerzen_cerulean);
        &:hover {
            background-color: rgba(47,150,244,.2);
        }
    }

    .outlined--white {
        color:var(--color_white);
        border-color:var(--color_white);

        & :hover {
            color:var(--color_offerzen_cerulean);
        }
    }

    .purple {
        @mixin button;
        background-color: var(--color_offerzen_purple);

        &:hover {
            background-color: var(--color_offerzen_purple_secondary);
        }
    }

    .cyan {
        @mixin button;
        background-color: var(--color_offerzen_tiel);
        color:var(--color_offerzen_navy);

        &:hover {
            background-color: var(--color_offerzen_tiel-background);
        }
    }
</style>